import { render, staticRenderFns } from "./bbszzy.vue?vue&type=template&id=0bc4c9d3&"
import script from "./bbszzy.vue?vue&type=script&lang=js&"
export * from "./bbszzy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports